module.exports = {"id":"198504","name":"Josip Drmić","rating":"74","photo":"./data/images/photos/0/198504.png","club":{"name":"Bor. M'gladbach","logo":"./data/images/clubs/Bor.M'gladbach.png"},"positions":["BU","MD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JosipDrmic0.json
// module id = 2195
// module chunks = 0